// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2cml5","content":"LayoutSettings_content__17lgh"};